import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarketplace = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.18928 3.48621C5.95871 2.61658 5.16921 2 4.25633 2H2L1.88338 2.00673C1.38604 2.06449 1 2.48716 1 3L1.00673 3.11662C1.06449 3.61396 1.48716 4 2 4H4.256L7.68719 22.873C6.95925 23.5144 6.5 24.4535 6.5 25.5C6.5 27.433 8.067 29 10 29C11.933 29 13.5 27.433 13.5 25.5C13.5 24.9632 13.3791 24.4546 13.1632 24H19.8368C19.6209 24.4546 19.5 24.9632 19.5 25.5C19.5 27.433 21.067 29 23 29C24.933 29 26.5 27.433 26.5 25.5C26.5 23.567 24.933 22 23 22H9.562L9.017 19H23.5127L23.6928 18.9946C25.0644 18.9129 26.2157 17.9037 26.4643 16.5367L27.9839 8.17889L27.9981 8.06449C28.0359 7.49662 27.5849 7 27 7H6.835L6.22407 3.64223L6.18928 3.48621ZM8.5 25.5C8.5 24.6716 9.17157 24 10 24C10.8284 24 11.5 24.6716 11.5 25.5C11.5 26.3284 10.8284 27 10 27C9.17157 27 8.5 26.3284 8.5 25.5ZM23 24C22.1716 24 21.5 24.6716 21.5 25.5C21.5 26.3284 22.1716 27 23 27C23.8284 27 24.5 26.3284 24.5 25.5C24.5 24.6716 23.8284 24 23 24ZM23.5127 17H8.653L7.198 9H25.802L24.4965 16.1789L24.4682 16.2949C24.3406 16.7096 23.9557 17 23.5127 17Z"
	})
});
export default SvgMarketplace;
